import React, { useState } from 'react';
import fr from 'facet-rest';
import { useCollectionStepper } from 'Hooks/useCollectionStepper';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { FDPrimaryActionButton, FDSecondaryActionButton, FDStack } from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  GoalDetailOutcomesSelectorContent,
} from './GoalDetailOutcomesSelectorContent';

export const GuidedHouseholdReviewLayoutGoalDetailOutcomesSelector = withGuidedHouseholdReviewLayout(({ collection }) => {
  const {
    resource,
    next,
    previous,
    isStart,
    isEnd,
    setIndex,
  } = useCollectionStepper(collection);

  const { displayErrorMessage } = useSnackbarContext();
  const { setPageContentCollection, pageContentResource } = usePageContentContext();
  const [submitting, setSubmitting] = useState(false);
  const submitPage = async () => {
    try {
      setSubmitting(true);
      setPageContentCollection(await pageContentResource.submit());
    } catch (err) {
      displayErrorMessage(err, err?.errors || 'We encountered an error, please try again');
    } finally {
      setSubmitting(false);
    }
  };

  // Only override back if we are not at the start
  const backButton = isStart
    ? <SecondaryActionButtonRel relationship={pageContentResource.relationship(fr.relationships.previousLink.name)} label={resource.attr('backButtonLabel')} />
    : <FDSecondaryActionButton onClick={previous} label={resource.attr('backButtonLabel')} />;

  // Only override next if we are not at the end
  const nextButton = isEnd
    ? <FDPrimaryActionButton label={resource.attr('primaryActionLabel')} onClick={submitPage} loading={submitting} />
    : <FDPrimaryActionButton onClick={next} label={resource.attr('primaryActionLabel')} />;

  return (
    <>
      <GoalDetailOutcomesSelectorContent collection={collection} resource={resource} setIndex={setIndex} />
      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2} paddingY={2}>
        {backButton}
        {nextButton}
      </FDStack>
    </>

  );
}, { customButtons: true, hideTitle: true });
